import { useCallback, useMemo, useState } from 'react';
import { BigNumber } from 'ethers';
import { UseQueryResult } from '@tanstack/react-query';
import { Token } from '@app/types/token';
import { CartSubtotals } from '@app/helpers/nft/nftCartHelpers';

type Props = {
  allowancesQueries: UseQueryResult<
    { value: any; formattedValue: string; contractAddress: string } | null,
    unknown
  >[];
  cartSubtotals: CartSubtotals;
  isLoadingAllowances: boolean;
};

type TokenToApprove = {
  token: Token;
  totalPrice: BigNumber;
};

export const useCartTokensToApprove = (data: Props) => {
  const { allowancesQueries, cartSubtotals, isLoadingAllowances } = data;

  return useMemo(() => {
    const tokensToApprove: TokenToApprove[] = [];

    if (!isLoadingAllowances) {
      const allowances = allowancesQueries.map(query => {
        return {
          value: BigNumber.from(query.data!.value),
          contractAddress: query.data!.contractAddress.toLowerCase()
        };
      });

      allowances.forEach(allowance => {
        const group = cartSubtotals.get(allowance.contractAddress);

        if (allowance.value.lt(group?.total as BigNumber)) {
          tokensToApprove.push({
            token: group?.token as Token,
            totalPrice: group?.total as BigNumber
          });
        }
      });
    }

    return tokensToApprove;
  }, [allowancesQueries, cartSubtotals, isLoadingAllowances]);
};
